<template>
  <input
    v-model="inputVal"
    v-mask="'##/##/####'"
    type="tel"
    :name="name"
    placeholder="mm/dd/yyyy"
    v-on="{
      ...$listeners,
      input: event => $emit('input', convertToIso(event.target.value)),
      blur: handleBlur
    }"
  >
</template>

<script>

import { mask } from 'vue-the-mask';
import { parse, formatISO, format } from 'date-fns';

export default {
  name: "DateInput",
  directives: {
    mask
  },
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  data() {
    const parsedValue = parse(this.value, 'yyyy-MM-dd', new Date('1970-01-01'));
    return {
      inputVal: (parsedValue instanceof Date && !isNaN(parsedValue)) ? format(parsedValue, 'MM/dd/yyyy') : ''
    };
  },
  methods: {
    convertToIso(d, formatString = 'MM/dd/yyyy', yearLen = 4) {
      const splitVal = d.split("/");
      // before even bothering to parse, check that we have 2 slashes and the last chunk is the proper amount
      if (splitVal.length === 3 && splitVal[2].length === yearLen) {
        // attempt to parse the date
        const isoDate = parse(d, formatString, new Date('1970-01-01'));
        // if it is not an Invalid Date
        if (isoDate instanceof Date && !isNaN(isoDate)) {
          // reformat it as ISO with just the date and return
          return formatISO(isoDate, {representation: 'date'});
        }
      }
      // invalid date, return empty string
      return "";
    },
    handleBlur() {
      // when we click away we want to clear this out unless it's a valid date, or if it's a valid date with a 2 digit year
      if (this.convertToIso(this.inputVal) === "") {
        const splitVal = this.inputVal.split("/");
        // we have 2 slashes and the last chunk has 2 digits
        if (splitVal.length === 3 && splitVal[2].length === 2) {
          // attempt to parse the date again this time using 2 digit year format and length
          const attemptTwo = this.convertToIso(this.inputVal, 'MM/dd/yy', 2);
          if (attemptTwo !== "") {
            // if we parsed ok, reparse and reformat to mm/dd/yyyy for our inputVal
            this.inputVal = format(parse(attemptTwo, "yyyy-MM-dd", new Date()),'MM/dd/yyyy');
            // emit the ISO formatted date
            this.$emit('input', attemptTwo);
            return;
          }
        }
        // we had an invalid date and it also wasn't a valid date with 2 digit year, wipe it out
        this.inputVal = "";
      }
    }
  }
}
</script>

<style scoped>

</style>